import { render, staticRenderFns } from "./AccountsChart.vue?vue&type=template&id=32c847ef&"
import script from "./AccountsChart.vue?vue&type=script&lang=js&"
export * from "./AccountsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports